import { create } from "zustand";

const useTabsSystemStore = create((set) => ({
  openTabs: [],
  activeTab: "dashboard",

  addNewTab: (item) =>
    set((state) => ({
      openTabs: [...item],
    })),

  closeTab: (tabKey) =>
    set((state) => {
      const filteredTabs = state.openTabs.filter((tab) => tab.key !== tabKey);

      let nextActiveTab = state.activeTab;

      // If closing active tab → switch to another
      if (state.activeTab === tabKey) {
        nextActiveTab =
          filteredTabs[filteredTabs.length - 1]?.key || "dashboard";
      }

      return {
        openTabs: filteredTabs,
        activeTab: nextActiveTab,
      };
    }),

  setActiveTab: (key) =>
    set(() => ({
      activeTab: key,
    })),
}));

export default useTabsSystemStore;
